<template>
  <q-page padding class="container">
    <PageHeader
      title="Listagem de Documentos"
      :backRoute="{ name: 'home' }"
      backBehavior="route"
    />
    <div
      class="row col-12 text-brand-5 text-weight-bold q-mt-lg container-inputs items-center"
    >
      <div class="row col-12">
        <div class="col-md col-sm-6 col-xs-6">
          <div>Unidade</div>
          <ListaUnidadesSelect />
        </div>
        <div class="col-md col-sm-6 col-xs-6 q-ml-sm">
          <div>Nome</div>
          <q-input debounce="1000" v-model="filtros.nome" dense outlined>
          </q-input>
        </div>
        <div class="col-md col-sm-5 col-xs-5 q-ml-sm">
          <SelecaoCategoriaDocumento
            @enviarCategoria="receberCategoriaFiltro"
            :tipoCategoriaUuid="filtros.tipoCategoriaUuid"
          />
        </div>
      </div>
      <div class="row col-12">
        <div class="col-md col-sm-5 col-xs-5">
          <SelecaoTipoDocumento
            :categoriaUuid="filtros.categoria.uuid"
            :model="filtros.tipo"
            @enviarTipo="receberTipoFiltro"
          />
        </div>
        <div class="col-md col-sm-6 col-xs-6 q-ml-sm">
          <div>Arquivo Vinculado</div>
          <q-select
            v-model="filtros.arquivo"
            :options="options.arquivoOptions"
            dense
            input-debounce="1000"
            outlined
          />
        </div>
        <div class="col-md col-sm-6 col-xs-6 q-ml-sm">
          <div>Status</div>
          <q-select
            v-model="filtros.status"
            :options="options.statusOptions"
            multiple
            map-options
            option-label="label"
            option-value="value"
            input-debounce="1000"
            dense
            outlined
          />
        </div>
      </div>
      <div class="row col-12">
        <div class="col-md col-sm-5 col-xs-6">
          <div class="texto-titulo-input">Data de Emissão</div>
          <q-input
            v-model="filtros.vigencia"
            dense
            outlined
            class="input"
            placeholder="DD/MM/AAAA"
            input-debounce="1000"
            mask="##/##/####"
            :rules="[
              (val) =>
                val == '' || val.length == 10 || 'Digite a Data Completa',
            ]"
          >
            <template v-slot:append>
              <q-icon name="event" class="cursor-pointer">
                <q-popup-proxy
                  cover
                  transition-show="scale"
                  transition-hide="scale"
                >
                  <q-date
                    v-model="filtros.vigencia"
                    :locale="myLocale"
                    mask="DD/MM/YYYY"
                    :rules="[
                      (val) =>
                        val == '' ||
                        val.length == 10 ||
                        'Digite a Data Completa',
                    ]"
                  >
                    <div class="row items-center justify-end">
                      <q-btn
                        v-close-popup
                        label="Fechar"
                        color="primary"
                        flat
                      />
                    </div>
                  </q-date>
                </q-popup-proxy>
              </q-icon>
            </template>
          </q-input>
        </div>
        <div class="col-md col-sm-5 col-xs-5 q-ml-sm">
          <div class="texto-titulo-input">Data de Vencimento</div>
          <q-input
            v-model="filtros.vencimento"
            dense
            outlined
            class="input"
            placeholder="DD/MM/AAAA"
            input-debounce="1000"
            mask="##/##/####"
            :rules="[
              (val) =>
                val == '' || val.length == 10 || 'Digite a Data Completa',
            ]"
          >
            <template v-slot:append>
              <q-icon name="event" class="cursor-pointer">
                <q-popup-proxy
                  cover
                  transition-show="scale"
                  transition-hide="scale"
                >
                  <q-date
                    v-model="filtros.vencimento"
                    :locale="myLocale"
                    mask="DD/MM/YYYY"
                    :rules="[
                      (val) =>
                        val == '' ||
                        val.length == 10 ||
                        'Digite a Data Completa',
                    ]"
                  >
                    <div class="row items-center justify-end">
                      <q-btn
                        v-close-popup
                        label="Fechar"
                        color="primary"
                        flat
                      />
                    </div>
                  </q-date>
                </q-popup-proxy>
              </q-icon>
            </template>
          </q-input>
        </div>
        <div class="col-md col-sm-5 col-xs-5 q-ml-sm">
          <div>Vencimento (dias)</div>
          <q-input
            v-model="filtros.vencimentoDias"
            debounce="1000"
            dense
            outlined
          >
          </q-input>
        </div>
      </div>
    </div>
    <div class="row col-12 q-mt-lg">
      <p></p>
      <q-btn
        class="q-mt-xs"
        label="Adicionar"
        no-caps
        color="positive"
        :outline="!rightDrawerOpen"
        icon="add"
        @click="rightDrawerOpen = !rightDrawerOpen"
      />
    </div>
    <div class="q-mt-xl">
      <div class="row col-12 q-my-lg justify-between items-center">
        <span
          class="texto-titulo-tabela text-brand-5 text-subtitle1 text-weight-bold"
        >
          Documentos Criados
        </span>
      </div>
      <q-table
        :columns="columns"
        :rows="listaDocumentos"
        :loading="loading"
        dense
        color="primary"
        hide-bottom
        no-data-label="Nenhum documento criado"
        class="tabela-tamanho-fixo"
        flat
        v-model:pagination="pagination"
        table-header-class="bg-accent text-weight-bold"
        @request="handleRequest"
        binary-state-sort
        :rows-per-page-options="[0]"
      >
        <template v-slot:body-cell-nome="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.nome }}
          </q-td>
        </template>
        <template v-slot:body-cell-descricao="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.descricao }}
          </q-td>
        </template>
        <template v-slot:body-cell-vencimento="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{
              props.row.vencimento?.split(" ")[0].split("-").reverse().join("/")
            }}
          </q-td>
        </template>
        <template v-slot:body-cell-emissao="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{
              props.row.vigencia?.split(" ")[0].split("-").reverse().join("/")
            }}
          </q-td>
        </template>
        <template v-slot:body-cell-status="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            <div
              :style="
                props.row.status == 'valido'
                  ? 'background: #e8ffec; width: fit-content; padding: 0px 5px'
                  : props.row.status == 'vencido'
                  ? 'background:#ffe9e9; color: #850202; width: fit-content; padding: 0px 5px'
                  : props.row.status == 'revalidado'
                  ? 'background:#fefed1; width: fit-content; padding: 0px 5px'
                  : props.row.status == 'inativo'
                  ? 'background:#9BA4B5; width: fit-content; padding: 0px 5px'
                  : ''
              "
              class="row items-center"
            >
              <div
                v-if="props.row.status == 'valido'"
                class="elipse q-mr-xs bg-positive"
              ></div>
              <div
                v-if="props.row.status == 'revalidado'"
                class="elipse q-mr-xs bg-warning"
              ></div>
              <div
                v-if="props.row.status == 'vencido'"
                class="elipse q-mr-xs"
                style="background: red"
              ></div>
              <div
                v-if="props.row.status == 'inativo'"
                class="elipse q-mr-xs"
                style="background: #383737"
              ></div>
              <span
                v-if="props.row.status != 'inativo'"
                class="row justify-center text-brand-5"
              >
                {{
                  `${props.row.status
                    ?.substring(0, 1)
                    .toUpperCase()}${props.row.status?.substring(1)}`
                }}
              </span>
              <span
                v-if="props.row.status == 'inativo'"
                class="row justify-center text-brand-5"
              >
                Obsoleto
              </span>
            </div>
          </q-td>
        </template>
        <template v-slot:body-cell-detalhe="props">
          <q-td :props="props">
            <router-link
              :to="{
                name: 'documentos-detalhe',
                params: { uuid: props.row.uuid },
              }"
            >
              <q-btn icon="article" flat color="blue-6" round />
            </router-link>
          </q-td>
        </template>
        <template v-slot:body-cell-excluir="props">
          <q-td :props="props">
            <q-btn
              icon="delete"
              flat
              color="red"
              round
              @click="abrirModalExcluir(props.row.uuid)"
            />
          </q-td>
        </template>
      </q-table>
      <div class="row justify-start q-mt-md">
        <q-pagination
          :disable="disable"
          v-model="pagination.page"
          color="brand-5"
          active-color="secondary"
          active-text-color="white"
          :max="pagesNumber"
          :max-pages="5"
          :boundary-numbers="false"
          :direction-links="true"
          size="sm"
        />
      </div>
    </div>
    <Transition name="slide-fade">
      <q-card v-if="rightDrawerOpen" class="drawer-modal">
        <div class="row q-pa-md text-weight-bold">
          <div class="row col-12 items-center">
            <q-icon
              style="cursor: pointer"
              name="close"
              class="q-mr-md"
              size="22px"
              @click="rightDrawerOpen = false"
            /><span style="font-size: 17px">Adicionar Documento</span>
          </div>
        </div>
        <q-scroll-area style="width: 100%; height: 89%">
          <div
            class="column col-12 justify-between no-wrap"
            style="height: 90%"
          >
            <div class="q-px-md text-weight-bold">
              <div class="col-md-12 q-mt-xs">
                <div class="texto-titulo-input q-mb-xs">Nome</div>
                <q-input
                  v-model="documento.nome"
                  dense
                  outlined
                  class="input"
                  placeholder="Nome documento"
                />
              </div>
              <div class="q-mt-sm">
                <SelecaoCategoriaDocumento
                  @enviarCategoria="receberCategoria"
                  :tipoCategoriaUuid="tipo.categoriaUuid"
                />
              </div>
              <div class="q-mt-sm">
                <SelecaoTipoDocumento
                  :categoriaUuid="categoria.uuid"
                  @enviarTipo="receberTipo"
                />
              </div>
              <div class="row col-12 q-mt-sm">
                <div class="col-12 q-mr-sm">
                  <div class="texto-titulo-input q-mb-xs">Data de Emissão</div>
                  <q-input
                    v-model="documento.vigencia"
                    dense
                    outlined
                    class="input"
                    placeholder="DD/MM/AAAA"
                    mask="##/##/####"
                  >
                    <template v-slot:append>
                      <q-icon name="event" class="cursor-pointer">
                        <q-popup-proxy
                          cover
                          transition-show="scale"
                          transition-hide="scale"
                        >
                          <q-date
                            v-model="documento.vigencia"
                            :locale="myLocale"
                            mask="DD/MM/YYYY"
                          >
                            <div class="row items-center justify-end">
                              <q-btn
                                v-close-popup
                                label="Fechar"
                                color="primary"
                                flat
                              />
                            </div>
                          </q-date>
                        </q-popup-proxy>
                      </q-icon>
                    </template>
                  </q-input>
                </div>
              </div>
              <div class="row col-12 q-mt-sm">
                <div class="col-12 q-mr-sm">
                  <div class="texto-titulo-input q-mb-xs">
                    Data de Vencimento
                  </div>
                  <q-input
                    v-model="documento.vencimento"
                    dense
                    outlined
                    class="input"
                    placeholder="DD/MM/AAAA"
                    mask="##/##/####"
                  >
                    <template v-slot:append>
                      <q-icon name="event" class="cursor-pointer">
                        <q-popup-proxy
                          cover
                          transition-show="scale"
                          transition-hide="scale"
                        >
                          <q-date
                            v-model="documento.vencimento"
                            :locale="myLocale"
                            mask="DD/MM/YYYY"
                          >
                            <div class="row items-center justify-end">
                              <q-btn
                                v-close-popup
                                label="Fechar"
                                color="primary"
                                flat
                              />
                            </div>
                          </q-date>
                        </q-popup-proxy>
                      </q-icon>
                    </template>
                  </q-input>
                </div>
              </div>
              <div class="col-md-12 q-mt-md">
                <div class="texto-titulo-input q-mb-xs">
                  Descrição do Documento
                </div>
                <q-input
                  :input-style="{ maxHeight: '100px' }"
                  outlined
                  autogrow
                  placeholder="Descrição"
                  v-model="documento.descricao"
                />
              </div>
            </div>
            <div class="q-px-md q-mt-md q-pb-sm">
              <q-btn
                dense
                icon="add"
                label="Criar Documento"
                no-caps
                color="positive"
                @click="criarDocumento()"
              />
            </div>
          </div>
        </q-scroll-area>
      </q-card>
    </Transition>
    <div
      v-if="rightDrawerOpen"
      @click="rightDrawerOpen = false"
      class="mascara"
    ></div>

    <DialogConfirmDesign
      :mensagem="modalExcluir.mensagem"
      :exibir="modalExcluir.exibir"
      :titulo="modalExcluir.titulo"
      @resultado="confirmarExcluir"
    />
  </q-page>
</template>

<script>
import { onMounted, ref, computed, watch } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import { useRoute } from "vue-router";
import { receberFiltro } from "../../requisicao/composables/receberFiltro";
import { watchDebounced } from "@vueuse/core";
import SelecaoTipoDocumento from "../components/SelecaoTipoDocumento.vue";
import SelecaoCategoriaDocumento from "../components/SelecaoCategoriaDocumento.vue";
import ListaUnidadesSelect from "../../organizacional/unidade/component/ListaUnidadesSelect.vue";
import DialogConfirmDesign from "../../../components/DialogConfirmDesign.vue";
import PageHeader from "../../../components/PageHeader.vue";

const columns = [
  {
    name: "nome",
    label: "Nome",
    align: "left",
    field: "nome",
    sortable: true,
  },
  {
    name: "descricao",
    label: "Descrição",
    align: "left",
    field: "descricao",
    sortable: true,
  },
  {
    name: "emissao",
    label: "Emissão",
    field: "vigencia",
    align: "left",
    sortable: true,
  },
  {
    name: "vencimento",
    label: "Vencimento",
    field: "vencimento",
    align: "left",
    sortable: true,
  },
  {
    name: "status",
    label: "Status",
    align: "left",
    field: "status",
    sortable: true,
  },
  {
    name: "detalhe",
    label: "Detalhe",
    align: "center",
  },
  {
    name: "excluir",
    label: "Excluir",
    align: "center",
  },
];

const converterParaData = (stringData) => {
  const partes = stringData.split(" ")[0].split("-");

  return new Date(partes[0], partes[1] - 1, partes[2]);
};

export default {
  components: {
    SelecaoTipoDocumento,
    SelecaoCategoriaDocumento,
    ListaUnidadesSelect,
    DialogConfirmDesign,
    PageHeader,
  },
  setup() {
    const store = useStore();
    const quasar = useQuasar();
    const route = useRoute();

    const rightDrawerOpen = ref(false);
    const filtrosSessao = receberFiltro();
    const categoria = ref({ nome: "", uuid: "", descricao: "" });
    const tipo = ref({ nome: "", uuid: "", descricao: "", categoriaUuid: "" });
    const documento = ref({
      nome: "",
      descricao: "",
      vigencia: "",
      vencimento: "",
    });
    const resetarTipo = ref(0);
    const listaDocumentos = ref([]);
    const filtrar = ref("");
    const igual = ref(false);
    const valorOrdenacao = ref("");
    const pagination = ref({
      sortBy: "descricao",
      descending: true,
      page: 1,
      rowsPerPage: 10,
      rowsNumber: 6,
    });
    let loading = ref(false);
    let disable = ref(false);
    const filtros = ref({
      nome: "",
      categoria: { nome: "", uuid: "" },
      tipo: { nome: "", uuid: "" },
      tipoCategoriaUuid: "",
      vencimento: "",
      vigencia: "",
      vencimentoDias: route.params?.vencimentoEmDias,
      status: [
        {
          label: "",
          value: "",
        },
      ],
      arquivo: { label: "Todos", value: "" },
    });

    const options = ref({
      statusOptions: [
        { label: "Válido", value: "valido" },
        { label: "Vencido", value: "vencido" },
        { label: "Revalidado", value: "revalidado" },
        { label: "Obsoleto", value: "inativo" },
      ],
      arquivoOptions: [
        { label: "Todos", value: "" },
        { label: "Com", value: "sim" },
        { label: "Sem", value: "nao" },
      ],
    });

    const modalExcluir = ref({
      exibir: false,
      mensagem: "",
      titulo: "Confirmar Exclusão",
      documentoUuid: null,
    });

    const listarDocumentos = async (
      page = 1,
      rowsPerPage = 6,
      ordenacao = { nome: "desc" }
    ) => {
      if (!filtrosSessao.filtrar.value) {
        return;
      }
      await store.state.org.unidadeData.id;
      let vencimento = "";
      let vigencia = "";
      if (filtros.value.vencimento != "") {
        vencimento = `${filtros.value.vencimento
          ?.split("/")
          .reverse()
          .join("-")} 00:00:00`;
      }
      if (filtros.value.vigencia != "") {
        vigencia = `${filtros.value.vigencia
          ?.split("/")
          .reverse()
          .join("-")} 00:00:00`;
      }
      let array = [];
      filtros.value?.status.forEach((status) => {
        array.push(status.value);
      });
      try {
        disable.value = true;
        loading.value = true;

        const response = await store.dispatch("documento/listarDocumentos", {
          unidadeId: store.state.org.unidadeData.id,
          nome: filtros.value.nome,
          CategoriaUuid: filtros.value?.categoria?.uuid,
          TipoUuid: filtros.value?.tipo?.uuid,
          comArquivo: filtros.value?.arquivo?.value,
          status: array.slice().join(",") || undefined,
          vencimento: vencimento,
          vencimentoEmDias: filtros.value?.vencimentoDias,
          vigencia: vigencia,
          page: page,
          perPage: rowsPerPage,
          ordenacao: ordenacao,
        });
        listaDocumentos.value = response.data.resultado.dados;

        pagination.value.page = response.data.resultado.currentPage;
        pagination.value.rowsNumber = response.data.resultado.total;
        pagination.value.rowsPerPage = response.data.resultado.perPage;

        disable.value = false;
        loading.value = false;
      } catch (error) {
        console.log(error);
      }
    };

    const receberCategoria = (value) => {
      if (value == null || value == undefined || value == "") {
        categoria.value = {
          nome: "",
          uuid: "",
          descricao: "",
        };
        tipo.value = {
          nome: "",
          uuid: "",
          descricao: "",
        };
        return;
      }
      categoria.value = value;
    };

    const receberCategoriaFiltro = (value) => {
      if (value == null || value == undefined || value == "") {
        filtros.value.categoria = { nome: "", uuid: "" };
        filtros.value.tipo = { nome: "", uuid: "" };
        filtros.value.tipoCategoriaUuid = "";
        return;
      }
      filtros.value.categoria = value;
    };

    const receberTipoFiltro = (value) => {
      if (value == null || value == undefined || value == "") {
        filtros.value.tipo = { nome: "", uuid: "" };
        filtros.value.tipoCategoriaUuid = "";
        return;
      }
      filtros.value.tipoCategoriaUuid = value.categoriaUuid;
      filtros.value.tipo = value;
    };

    const receberTipo = (value) => {
      if (value == null || value == undefined || value == "") {
        tipo.value = {
          nome: "",
          uuid: "",
          descricao: "",
          categoriaUuid: "",
        };
        return;
      }
      tipo.value = value;
    };

    const criarDocumento = async () => {
      if (documento.value.nome == "" || tipo.value.uuid == "") {
        quasar.notify({
          message: "O campo nome e tipo não podem estar vazios.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      let vigencia = `${new Date()
        .toLocaleDateString("pt-BR", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        })
        .split("/")
        .reverse()
        .join("-")} 00:00:00`;
      if (documento.value.vigencia != "") {
        vigencia = `${documento.value.vigencia
          ?.split("/")
          .reverse()
          .join("-")} 00:00:00`;
      }
      if (documento.value.vencimento == "") {
        const dataString = vigencia.split(" ")[0];
        const partes = dataString.split("-");
        const data = new Date(partes[0], partes[1] - 1, partes[2]);
        data.setDate(data.getDate() + tipo.value.validade);
        documento.value.vencimento = data.toLocaleDateString("pt-BR", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        });
      }
      try {
        await store.dispatch("documento/criarDocumento", {
          nome: documento.value.nome,
          tipoUuid: tipo.value.uuid,
          descricao: documento.value.descricao,
          vigencia: vigencia,
          vencimento: `${documento.value.vencimento
            ?.split("/")
            .reverse()
            .join("-")} 00:00:00`,
        });
        quasar.notify({
          message: "Documento criado com sucesso.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        reset();
        rightDrawerOpen.value = false;
        listarDocumentos();
      } catch (error) {
        console.log(error);
        quasar.notify({
          message: "Erro ao criar documento.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const abrirModalExcluir = (uuid) => {
      modalExcluir.value.documentoUuid = uuid;
      modalExcluir.value.mensagem =
        "Tem certeza que deseja excluir esse Documento?";
      modalExcluir.value.exibir = true;
    };

    const confirmarExcluir = async (confirmado) => {
      modalExcluir.value.exibir = false;

      if (!confirmado) {
        modalExcluir.value.documentoUuid = null;
        return;
      }

      const uuid = modalExcluir.value.documentoUuid;

      try {
        await store.dispatch("documento/excluirDocumento", {
          uuid: uuid,
        });
        quasar.notify({
          message: "Documento excluido com sucesso.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        listarDocumentos();
      } catch (error) {
        quasar.notify({
          message: "Erro ao excluir documento.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }

      modalExcluir.value.documentoUuid = null;
    };

    const excluirDocumento = async (uuid) => {
      try {
        await store.dispatch("documento/excluirDocumento", {
          uuid: uuid,
        });
        quasar.notify({
          message: "Documento excluido com sucesso.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        listarDocumentos();
      } catch (error) {
        quasar.notify({
          message: "Erro ao excluir documento.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const reset = () => {
      documento.value = {
        nome: "",
        descricao: "",
        vigencia: "",
        validade: "",
      };
      categoria.value = {
        nome: "",
        uuid: "",
        descricao: "",
      };
      tipo.value = {
        nome: "",
        uuid: "",
        descricao: "",
        categoriaUuid: "",
      };
    };

    watch(
      () => store.state.org.unidadeData.id,
      () => {
        rightDrawerOpen.value = false;
        listarDocumentos();
      }
    );

    watch(
      () => filtrosSessao.filtros.value,
      () => {
        filtros.value = filtrosSessao.filtros.value;
      }
    );

    watch(
      () => filtrosSessao.filtrar.value,
      () => {
        listarDocumentos();
      }
    );

    watchDebounced(
      [
        () => filtros.value.nome,
        () => filtros.value.categoria,
        () => filtros.value.tipo,
        () => filtros.value.vencimento,
        () => filtros.value.vigencia,
        () => filtros.value.vencimentoDias,
        () => filtros.value.status,
        () => filtros.value.arquivo,
      ],
      () => {
        if (
          filtros.value.vencimento != "" &&
          filtros.value.vencimento.length != 10
        ) {
          return;
        }

        if (
          filtros.value.vigencia != "" &&
          filtros.value.vigencia.length != 10
        ) {
          return;
        }
        sessionStorage.setItem(
          "/doc/documento/listar",
          JSON.stringify(filtros.value)
        );
        listarDocumentos();
      },
      { debounce: 400 }
    );

    watch(
      () => documento.value.vigencia,
      () => {
        if (tipo.value.uuid != "") {
          const dataString = documento.value.vigencia.split("/").reverse();
          const partes = dataString;
          const data = new Date(partes[0], partes[1] - 1, partes[2]);
          data.setDate(data.getDate() + tipo.value.validade);
          documento.value.vencimento = data.toLocaleDateString("pt-BR", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
          });
        }
      }
    );

    watch(
      () => tipo.value.uuid,
      () => {
        if (documento.value.vigencia != "") {
          const dataString = documento.value.vigencia.split("/").reverse();
          const partes = dataString;
          const data = new Date(partes[0], partes[1] - 1, partes[2]);
          data.setDate(data.getDate() + tipo.value.validade);
          documento.value.vencimento = data.toLocaleDateString("pt-BR", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
          });
        }
      }
    );

    onMounted(() => {
      listarDocumentos();
    });

    const handleRequest = async (value) => {
      const ordenacao = {};

      if (valorOrdenacao.value == value.pagination.sortBy) {
        igual.value = !igual.value;
        ordenacao[valorOrdenacao.value] = igual.value ? "asc" : "desc";

        pagination.value.sortBy = valorOrdenacao.value;

        pagination.value.descending = igual.value ? false : true;

        listarDocumentos(
          pagination.value.page,
          pagination.value.rowsPerPage,
          ordenacao
        );
        return;
      }

      igual.value = false;

      valorOrdenacao.value = value.pagination.sortBy;
      pagination.value.sortBy = valorOrdenacao.value;

      pagination.value.descending = true;

      ordenacao[valorOrdenacao.value] = "desc";
      listarDocumentos(
        pagination.value.page,
        pagination.value.rowsPerPage,
        ordenacao
      );
    };

    watch(
      () => pagination.value.page,
      () => {
        listarDocumentos(pagination.value.page, pagination.value.rowsPerPage);
      }
    );

    return {
      columns,
      rightDrawerOpen,
      receberCategoria,
      categoria,
      receberTipo,
      filtrosSessao,
      tipo,
      documento,
      converterParaData,
      handleRequest,
      myLocale: {
        days: "Domingo_Segunda_Terça_Quarta_Quinta_Sexta_Sábado".split("_"),
        daysShort: "Dom_Seg_Ter_Quar_Quin_Sex_Sáb".split("_"),
        months:
          "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split(
            "_"
          ),
        monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split(
          "_"
        ),
        firstDayOfWeek: 1,
      },
      resetarTipo,
      criarDocumento,
      reset,
      listarDocumentos,
      listaDocumentos,
      filtrar,
      pagination,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      loading,
      disable,
      excluirDocumento,
      abrirModalExcluir,
      confirmarExcluir,
      modalExcluir,
      receberCategoriaFiltro,
      filtros,
      receberTipoFiltro,
      options,
    };
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}
.elipse {
  width: 12px;
  height: 12px;
  border-radius: 100px;
}
.container {
  height: 100%;
}
.drawer-modal {
  border: 2px solid black;
  position: absolute;
  right: 0;
  width: 450px;
  height: calc(100% - 10px);
  max-height: 650px;
  position: fixed;
  top: 106px;
  border-radius: 10px 1px 1px 10px;
  margin: 2px;
  z-index: 3;
}
.slide-fade-enter-active {
  transition: all 0.5s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(400px);
}
.titulo-modal {
  font-size: 15px;
}
.mascara {
  background-color: black;
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2;
  opacity: 0.4;
}
@media (max-width: 1400px) {
  .drawer-modal {
    height: 80%;
    overflow: hidden;
  }
}
@media (max-width: 1200px) {
  .drawer-modal {
    max-height: 80%;
    overflow: hidden;
  }
}
@media (max-width: 1000px) {
  .drawer-modal {
    max-height: 80%;
    top: 118px;
    overflow: hidden;
  }
}
@media (max-width: 900px) {
  .drawer-modal {
    max-height: 80%;
    top: 118px;
    overflow: hidden;
  }
}
@media (max-width: 700px) {
  .drawer-modal {
    max-height: 80%;
    overflow: hidden;
    top: 107px;
  }
}
@media (max-width: 700px) {
  .drawer-modal {
    max-height: 80%;
    overflow: hidden;
    top: 107px;
  }
}
@media (max-width: 600px) {
  .drawer-modal {
    max-height: 90%;
    overflow: hidden;
    top: 107px;
  }
}
</style>
